import axios from 'axios'
export default class AuthenticationService {
    static authenticateJwt(token) {
        return new Promise((fulfill, reject) => {
            axios.get(`/users/authenticate`,
                {headers: {"Authorization": `Bearer ${token}`}}
            ).then(response => {
                fulfill(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}